const traffic = {
  repair: {
    handleTime: '维修日期',
    mileage: '维修里程(km)',
    items: '维修项目',
    edit: '编辑维修',
    add: '新增维修',
    itemIdList: '维修项目列表',
    basicRepair: '常规维修',
    deepRepair: '其他维修',
    custom: '自定义',
    errorRepair: '请选择维修项目',
  },
  maintain: {
    handleTime: '保养日期',
    mileage: '保养里程(km)',
    items: '保养项目',
    edit: '编辑保养',
    add: '新增保养',
    itemIdList: '保养项目列表',
    nextTime: '下次保养日期',
    nextMileage: '下次保养里程',
    nextItems: '下次保养项目列表',
    basicMaintain: '常规保养',
    deepMaintain: '深度保养',
    cleanMaintain: '清洁保养',
    customized: '自定义',
    errorMaintain: '请选择保养项目',
    nextRemind:'是否提醒下次保养',
    tx:'提醒',
    btx:'不提醒',
    errornext:'请选择下次保养项目'
  },
  selectCar: '选择车辆',
  licensePlate: '车牌号',
  errorLicensePlate: '请输入车牌号',
  errorMileage: '请输入里程数（合法数字）',
  errorTime: '请选择日期',
  remark: '备注'
}
export default traffic